<template>
  <div class="c c-product-overview">
    <div class="c-product-overview__facets">
      <div v-if="allProductsOverviewLink" class="font-weight-bold pb-4 pt-2">
        <a
          :href="allProductsOverviewLink"
          class="text-primary text-decoration-none"
        >
          <i class="far fa-arrow-left"></i>
          {{
            getProductOverviewTranslations[
              'ProductsOverview.AllProductsOverview'
            ]
          }}
        </a>
      </div>
      <facets />
    </div>

    <div class="c-product-overview__results">
      <top-controls />
      <results />

      <pagination />
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex';
import facets from './facets.vue';
import pagination from './pagination.vue';
import results from './results.vue';
import topControls from './top-controls.vue';
import { gtagBaseShapesMapper } from '@modules/../util/helper.js';

export default {
  components: {
    facets,
    pagination,
    results,
    topControls
  },
  props: {
    allProductsOverviewLink: {
      type: String,
      default: null
    },
    categories: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters('translations', ['getProductOverviewTranslations']),
    ...mapGetters('productSearch', ['activeFacets']),
    ...mapState('productSearch', ['products', 'totalCount']),
    ...mapState(['culture'])
  },
  watch: {
    '$route.query': {
      handler() {
        this.setQuery(this.$route.query);
        this.getProducts();
      },
      deep: true
    },
    products() {
      const filters = [];
      for (const key of this.activeFacets) {
        const value = this.$route.query[key];
        if (Array.isArray(value)) {
          if (value.length) {
            filters.push({
              filter_name: key,
              filter_values: value.join('|')
            });
          }
        } else if (value && value !== '') {
          filters.push({
            filter_name: key,
            filter_values: value
          });
        }
      }

      try {
        window.gtag('event', 'view_item_list', {
          ...this.categories,
          filters,
          item_list_name: 'overview',
          items: gtagBaseShapesMapper(this.products.map(x => x.document)),
          page: this.$route.query.page || '1'
        });
      } catch(err) {
        console.error('Error while tracking conversion', err);
      }
    }
  },
  async mounted() {
    this.setPath(this.$route.path);
    this.setQuery(this.$route.query);

    await Promise.all([
      this.getPropertiesMetadata(),
      this.getProducts({ initialize: true }),
      this.getTranslations({
        culture: this.culture,
        dictionaryKey: 'ProductsOverview'
      })
    ]);
  },
  methods: {
    ...mapActions('productSearch', ['getPropertiesMetadata', 'getProducts']),
    ...mapActions('translations', ['getTranslations']),
    ...mapMutations('productSearch', ['setPath', 'setQuery'])
  }
};
</script>

<style lang="scss" scoped>
@import '@/css/src/utilities/_variables.scss';
@import '~bootstrap/scss/mixins';

.c-product-overview {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 20px;

  @include media-breakpoint-up(md) {
    gap: 30px;
  }

  &__facets {
    grid-column-start: 1;
    grid-column-end: 13;

    @include media-breakpoint-down(md) {
      position: sticky;
      top: 0;
      z-index: 54;
    }

    @include media-breakpoint-up(xl) {
      grid-column-end: 4;
    }
  }

  &__results {
    grid-column-start: 1;
    grid-column-end: 13;

    @include media-breakpoint-up(xl) {
      grid-column-start: 5;
    }
  }
}
</style>
